import { useMemo } from 'react';
import { ITableQueryData } from "types/frontend_models/table/ITableQueryData";
import { Filters, SortingRule } from "react-table";
import { ITableFilter, FilterOperators } from 'types/frontend_models/filtering/filters';
import { parseDateRangeString } from 'functions/parsers/DateRangeParsers';

interface IInitialQueryData
{
	filters: Filters<Object>,
	sortBy: SortingRule<Object>[]
}

export function useInitialTableFilterAndSortData(
	getTableQueryFromSearch: (previousQuery?: ITableQueryData | undefined) => ITableQueryData
)
{
	const initialData: IInitialQueryData = useMemo(() =>
	{
		let data: {
			filters: Filters<Object>,
			sortBy: SortingRule<Object>[]
		} = {
			filters: [],
			sortBy: []
		};

		const queryData = getTableQueryFromSearch();

		if (queryData.filters) {
			queryData.filters.forEach(f =>
			{
				// Converts a tablefilter to react-table filter format
				const filter = tableFilterToReactTableFilter(f);
				data.filters.push(filter);
			});
		}

		if (queryData.sorted) {
			// console.log('queryData.sorted', queryData.sorted);
			let id: string = queryData.sorted;
			let desc: boolean = false;
			if (queryData.sorted.startsWith('-')) {
				id = queryData.sorted.substring(1);
				desc = true;
			}

			let sortingRule: SortingRule<Object> = {
				id: id,
				desc: desc
			};
			data.sortBy.push(sortingRule);
		}

		return data;
	}, [getTableQueryFromSearch]);

	return initialData;
}

function tableFilterToReactTableFilter(tableFilter: ITableFilter): { id: string, value: any }
{
	switch (tableFilter.operator) {
		case FilterOperators.dateRange: {
			let dateRange = parseDateRangeString(tableFilter.value);
			return {
				id: tableFilter.key,
				value: dateRange
			}
		}
		default: {
			return {
				id: tableFilter.key, value: tableFilter.value
			};
		}
	}
}